import { ChangeDetectorRef, Component } from '@angular/core';
import { KfiStore } from '../../services/kfi-store';
import { BaseKfiPage } from '../base-kfi-page.component';
import { KfiService } from '../../services/kfi.service';

@Component({
  selector: 'boi-kfi-your-mortgage',
  templateUrl: './kfi-your-mortgage.page.html',
  styleUrls: ['./../../styles/kfi-pages.scss', './kfi-your-mortgage.page.scss']
})
export class KfiYourMortgagePage extends BaseKfiPage {
  public isFeeUpToDate = true;
  public isDprEnabled?: boolean;

  constructor(
    protected kfiStore: KfiStore,
    public changeDetectorRef: ChangeDetectorRef,
    public kfiService: KfiService
  ) {
    super(kfiStore);

    this.kfiService.isDprServiceEnabled().subscribe((isDprEnabled) => (this.isDprEnabled = isDprEnabled));
  }
}
